import  axiosI  from '../Service/service';
import {GET_ACTIVITY, GET_VISITORS, UPDATE_VISIT, GET_CHECKIN_DETAIL, GET_DEAL_CLAIMED_DETAIL} from './actionTypes';
import * as constants from '../Constants';

export const fetchVisitorsAction=(placeId,UserId)=>{
    return (dispatch => {
        return axiosI.get(`${constants.API.getCheckinDealClaimedDetailsApi}/${placeId}/${UserId}`).then(({data})=>{
            dispatch({
                type: GET_VISITORS,
                payload: data
            });
            return data;
        }).catch((err)=>{
            console.log(err);
        })
    })
};

export const fetchActivityAction=(placeId)=>{
    return (dispatch => {
        return axiosI.get(`${constants.API.getBusinessActivityApi}/${placeId}`).then(({data})=>{
            dispatch({
                type: GET_ACTIVITY,
                payload: data
            });
        }).catch((err)=>{
            console.log(err);
        })
    })
};

export const updateVisitAction=(PlaceId,UpdateValue)=>{
    return (dispatch => {
        return axiosI.post(constants.API.updateBusinessPanelSeenStatusApi,{PlaceId,UpdateValue}).then(()=>{
            dispatch({
                type: UPDATE_VISIT,
                payload: UpdateValue
            });
        }).catch((err)=>{
            console.log(err);
        })
    })
};
export const GetCheckInData=(PlaceId,UserId)=>{
  return (dispatch => {
    return axiosI.get(`${constants.API.getCheckinDetailsApi}/${PlaceId}/${UserId}`).then(({data})=>{
      dispatch({
        type: GET_CHECKIN_DETAIL,
        payload: data
      });
    }).catch((err)=>{
      console.log(err);
    })
  })
};
export const GetDealClaimedData=(PlaceId,UserId)=>{
  return (dispatch => {

    return axiosI.get(`${constants.API.getDealClaimedDetails}/${PlaceId}/${UserId}`).then(({data})=>{
      dispatch({
        type: GET_DEAL_CLAIMED_DETAIL,
        payload: data
      });
    })
  })
};